import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import style from "css/signup/signupComplete.module.css";
import SEOMeta from "component/app/SEOMeta";

function SignUpComplete() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const completed = location.state?.completed;

  useEffect(() => {
    if (!completed) {
      navigate("/signup", { replace: true });
    }
  }, [completed, navigate]);

  if (!completed) return null;

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <div className={style.page}>
      <SEOMeta
        title={t("signup.complete.seo.title")}
        description={t("signup.complete.seo.description")}
        keywords={t("signup.complete.seo.keywords")}
      />
      <div className={style.content}>
        <img
          className={style.icon}
          src={`${process.env.REACT_APP_CLIENT_URL}img/signup/signup_check.svg`}
          alt=""
        />
        <h1 className={style.title}>{t("signup.complete.title")}</h1>
        <p className={style.message}>
          <Trans
            i18nKey="signup.complete.message"
            components={{ br: <br /> }}
          />
        </p>
        <button
          type="button"
          className={style.goBtn}
          onClick={handleGoHome}
        >
          {t("signup.complete.goSite")}
        </button>
      </div>
    </div>
  );
}

export default SignUpComplete;
